import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { createContext, useContext, useMemo } from 'react';

function treeControllerFromUpdateState(updateState) {
  const obj = {
    updateState
  };
  obj.setExpanded = (id, expanded) => {
    obj.updateState(_a => {
      var {
          expandedIds
        } = _a,
        rest = __rest(_a, ["expandedIds"]);
      return Object.assign(Object.assign({}, rest), {
        expandedIds: Object.assign(Object.assign({}, expandedIds), {
          [id]: expanded !== false
        })
      });
    });
  };
  obj.toggleExpanded = id => {
    obj.updateState((_a, _b) => {
      var {
          expandedIds
        } = _a,
        rest = __rest(_a, ["expandedIds"]);
      var allNodes = _b.allNodes;
      const isExpandedState = expandedIds ? expandedIds[id] : undefined;
      const isExpanded = isExpandedState === true || allNodes[id] && allNodes[id].isActiveTrail && isExpandedState === undefined;
      return Object.assign(Object.assign({}, rest), {
        expandedIds: Object.assign(Object.assign({}, expandedIds), {
          [id]: !isExpanded
        })
      });
    });
  };
  obj.setMultipleExpanded = (ids, expanded) => {
    obj.updateState((_a, _b) => {
      var {
          expandedIds
        } = _a,
        rest = __rest(_a, ["expandedIds"]);
      var allNodes = _b.allNodes;
      const nodesToOpen = ids.map(id => allNodes[id]).filter(Boolean);
      return Object.assign(Object.assign({}, rest), {
        expandedIds: Object.assign(Object.assign({}, expandedIds), nodesToOpen.reduce((newExpandedIds, item) => {
          newExpandedIds[item.id] = expanded !== false;
          return newExpandedIds;
        }, {}))
      });
    });
  };
  obj.setActiveId = id => {
    obj.updateState(st => Object.assign(Object.assign({}, st), {
      activeId: id
    }));
  };
  return obj;
}
const noopUpdateState = _ => {
  /* noop */
};
const noopTreeController = treeControllerFromUpdateState(noopUpdateState);
const TreeControllerContext = createContext(noopTreeController);
function useTreeController() {
  return useContext(TreeControllerContext);
}
function useTreeNodeController(item) {
  const id = typeof item === 'string' ? item : item.id;
  const controller = useTreeController();
  return useMemo(() => ({
    toggleExpanded() {
      controller.toggleExpanded(id);
    },
    setExpanded(expanded) {
      controller.setExpanded(id, expanded);
    },
    setActive() {
      controller.updateState(st => {
        const {
            activeId
          } = st,
          rest = __rest(st, ["activeId"]);
        return activeId === id ? rest : st;
      });
      controller.setActiveId(id);
    }
  }), [controller, id]);
}
function useTreeNodesController(items) {
  const controller = useTreeController();
  return useMemo(() => ({
    setMultipleExpanded(expanded) {
      controller.setMultipleExpanded(items.map(item => item.id), expanded);
    }
  }), [controller, items]);
}

export { TreeControllerContext, noopTreeController, noopUpdateState, treeControllerFromUpdateState, useTreeController, useTreeNodeController, useTreeNodesController };
//# sourceMappingURL=useTreeController.js.map
